<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsBiz-skuFirstOrderReview',
  components: { PageTable },
}
</script>
